<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Impression : {{ data.name }}</h2>
  
  @if (data.detail) {
    <button mat-stroked-button color="primary" (click)="printDetails()" class="px-3 btn-preview-action" matTooltip="Afficher l'aperçu complet">
      <mat-icon class="me-1">visibility</mat-icon>
      <span>Aperçu</span>
    </button>
  }
</div>

<mat-dialog-content id="modalDialog" #modalDialog class="p-3 bg-light custom-pdf-dialog-content">
  <div class="pdf-viewer-container border rounded-3 bg-white shadow-sm overflow-hidden">
    <embed id="" [src]="pdfFile" type="application/pdf" class="w-100 pdf-embedded-frame">
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-white m-0 gap-2">
  <button mat-stroked-button mat-dialog-close cdkFocusInitial color="warn" class="px-4">
    <span>Fermer</span>
  </button>
</mat-dialog-actions>
